<template>
  <a-card
    title="查询"
    size="small"
    :headStyle="{
      background: '#f3f3f3',
    }"
  >
    <a-form layout="inline">
      <a-row>
        <a-col :span="8">
          <a-form-item labelAlign="left" label='订单号'>
            订单号
            <a-input type="text" placeholder="请输入订单号"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="4"></a-col>
        <a-col :span="4"></a-col>
        <a-col :span="4"></a-col>
        <a-col :span="4"></a-col>
      </a-row>
    </a-form>
  </a-card>
</template>